import Grid from "@mui/material/Grid";
import { Fragment } from "react";
import CellularTypes from "../Configuration/CellularTypes";
import EventTable from "./EventTable";
import { useAuthDataContext } from "../AuthDataProvider";
function DeviceEvents(props) {
  const { user } = useAuthDataContext();
  return (
    <Grid container spacing={3} justifyContent={"space-between"}>
      {CellularTypes.includes(props.deviceType) ? (
        <Fragment>
          <Grid item lg={4}>
            <h3>Reset Events</h3>
          </Grid>
          <Grid item lg={12}>
            <EventTable
              eventType="reset_events"
              coreId={props.coreId}
              deviceType={props.deviceType}
              open={false}
            />
          </Grid>
        </Fragment>
      ) : null}
      <Grid item lg={4}>
        <h3>Firmware Events</h3>
      </Grid>
      <Grid item lg={12}>
        <EventTable
          eventType="firmware_events"
          coreId={props.coreId}
          deviceType={props.deviceType}
          open={false}
        />
      </Grid>

      {CellularTypes.includes(props.deviceType) ? (
        <Fragment>
          <Grid item lg={4}>
            <h3>Status Events</h3>
          </Grid>
          <Grid item lg={12}>
            <EventTable
              eventType="status_events"
              coreId={props.coreId}
              deviceType={props.deviceType}
              open={false}
            />
          </Grid>
        </Fragment>
      ) : null}
      <Grid item lg={4}>
        <h3>Device Log Events</h3>
      </Grid>
      <Grid item lg={12}>
        <EventTable
          eventType="device_logs"
          coreId={props.coreId}
          deviceType={props.deviceType}
          open={true}
        />
      </Grid>
    </Grid>
  );
}

export default DeviceEvents;
